/**
 * Application configuration
 */

export const config = {
  // API base URL - points to Supabase Edge Functions
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:54321/functions/v1/api",

  // Supabase anon key for edge function auth
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "",

  // API version prefix
  apiVersion: "/v1",

  // Session token header name
  sessionTokenHeader: "X-Session-Token",

  // Currency
  currency: "ZAR",

  // Brand colors (can be overridden via CSS variables)
  brandColor: {
    primary: "#0ea5e9",
    primaryHover: "#0284c7",
  },
} as const;

/**
 * Get full API URL
 * Handles path normalization to prevent double slashes
 */
export function getApiUrl(path: string): string {
  // Remove trailing slash from base URL
  const baseUrl = config.apiBaseUrl.replace(/\/+$/, "");
  // Ensure path starts with a slash
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${config.apiVersion}${normalizedPath}`;
}
